import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-foreground-950">
                <i className="ri-film-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">三级片电影</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-300">
              三级片电影是一个专注于三级影片内容展示与信息聚合的影视门户，汇聚都市、古装、悬疑、江湖与奇幻等多元题材，为影迷提供最新的影片资讯、剧情介绍与分类浏览体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-300 hover:text-accent-500 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-300 hover:text-accent-500 transition-colors">
                  影片搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 hover:text-accent-500 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-300 hover:text-accent-500 transition-colors">
                  免责声明
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">影片分类</h4>
            <ul className="space-y-2 text-sm">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-foreground-300 hover:text-accent-500 transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-foreground-400">
          <p>© {new Date().getFullYear()} 三级片电影 · 本站内容仅供演示与信息参考，不提供任何在线播放服务。</p>
          <p className="whitespace-nowrap">适合成年人浏览 · 请理性观影</p>
        </div>
      </div>
    </footer>
  );
}